import cn from "classnames";
import PropTypes from "prop-types";

function References({
  ariaLabel = undefined,
  children,
  className = undefined,
  outlined = false,
  role = undefined,
  ...rest
}) {
  return (
    <div
      aria-label={ariaLabel}
      className={cn(
        "references",
        {
          outlined,
        },
        className
      )}
      role={role}
      {...rest}
    >
      <div>
        <div className="row">
          <div className="col">
            <p className="b">References:</p>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default References;

References.propTypes = {
  ariaLabel: PropTypes.string,
  classes: PropTypes.string,
  outlined: PropTypes.bool,
  role: PropTypes.string,
};
